<template>
  <div class="task-all" v-loading="isDeleteOk">
    <!-- header -->
    <div class="task-header">
      <div class="header-left"></div>
      <div class="header-right">
        <!-- 再次发布按钮 -->
        <el-button class="pub-again-btn" v-show="isPubAgain&&checkPub()" @click="pubAgain()"
          >再次发布</el-button
        >
        <!-- 发布按钮 -->
        <el-button class="pub-btn" v-show="isPub&&checkPub()" @click="pubAgain()">发布</el-button>
        <!-- 编辑按钮 -->
        <el-button class="edit-btn" v-show="isEdit&&checkEdit()" @click="editTask()">编辑</el-button>
        <!-- 删除按钮 -->
        <el-button class="del-btn" v-show="isDel&&checkDelete()" @click="delPop()"
          >删除</el-button
        >
        <!-- 下架按钮 -->
        <el-button class="down-btn" v-show="isDown&&checkDown()" @click="downPop()"
          >下架</el-button >

        <!-- 返回按钮 -->
        <el-button class="back-btn" @click="handleClick">返回</el-button>
      </div>
    </div>
    <!-- main-top -->
    <div class="main-top-content">
      <div class="left">
        <div class="content">
          <div class="title">课程编号:</div>
          <div class="text">{{ Alldata.code }}</div>
        </div>
      </div>
      <div class="verDivider"></div>
      <div class="middle">
        <div class="content">
          <div class="title">创建人:</div>
          <el-tooltip
                :content="Alldata.creatBy+'('+Alldata.creatUserRealName+')'"
                placement="bottom"
                effect="light"
              >
                <div class="text">
                  <div class="hide"> {{ Alldata.creatBy }}({{ Alldata.creatUserRealName }})</div>
                </div></el-tooltip
              >
        </div>
        <div class="content">
          <div class="title">创建时间:</div>
          <el-tooltip
                :content="Alldata.creatDate"
                placement="bottom"
                effect="light"
              >
                <div class="text">
                  <div class="hide"> {{ Alldata.creatDate }}</div>
                </div></el-tooltip
              >
        </div>
        <div class="content">
          <div class="title">发布人:</div>
          <el-tooltip
                :content="Alldata.publishBy+formatPub(Alldata.publishUserRealName)"
                placement="bottom"
                effect="light"
              >
                <div class="text">
                  <div class="hide">  {{ Alldata.publishBy }}{{ formatPub(Alldata.publishUserRealName)}}</div>
                </div></el-tooltip
              >
        </div>
        <div class="content">
          <div class="title">发布时间:</div>
          <el-tooltip
                :content="Alldata.publishDate"
                placement="bottom"
                effect="light"
              >
                <div class="text">
                  <div class="hide"> {{ Alldata.publishDate }}</div>
                </div></el-tooltip
              >
        </div>
      </div>
      <div class="verDivider"></div>
      <div class="right">
        <div class="content">
          <div class="title">任务状态:</div>
          <div class="task-status">
            <div
              :style="{
                ...dot,
                'background-color':
                  Alldata.status === 2
                    ? '#00b627'
                    : Alldata.status === 3
                    ? '#FF4141'
                    : Alldata.status === 0
                    ? '#FFA800'
                    : Alldata.status === 4
                    ? '#1C69D4'
                    : '#999A9C',
              }"
            ></div>
            &nbsp;
            <div class="content">{{ getStatus(Alldata.status) }}</div>
          </div>
        </div>
      </div>
    </div>
    <!-- content -->
    <div class="task-main-content">
      <div class="header">

        <div class="title"></div>
      </div>
      <!--隔离线 -->
      <div class="block_42 flex-col"></div>
      <div class="content-all">
        <div class="content-h">
          <div class="content">
            <div class="h-title">任务类型</div>
            <div class="h-text">{{ getBizType(Alldata.bizType) }}</div>
          </div>
        </div>
        <div class="box_23 flex-col"></div>
        <div class="content-main">
          <div class="main-h">
            <div class="content">
              <div class="h-title">任务名称</div>
              <el-tooltip
                :content="Alldata.name"
                placement="bottom"
                effect="light"
              >
                <div class="h-text">
                  <div class="hide">{{ Alldata.name }}</div>
                </div></el-tooltip
              >
            </div>
            <div class="content">
              <div class="h-title">调研链接</div>
              <el-tooltip
                :content="Alldata.bizUrl"
                placement="bottom"
                effect="light"
              >
                <div class="h-text">
                  <div class="hide">{{ Alldata.bizUrl }}</div>
                </div></el-tooltip
              >
            </div>
            <div class="content">
              <div class="h-title">业务团队</div>
              <div class="h-text">
                {{ Alldata.teamTypeDesc }}-{{ Alldata.teamTypeChildDesc }}
              </div>
            </div>
            <div class="content">
              <div class="h-title">任务有效期</div>
              <div class="h-text">
                {{ formatDate(Alldata.startDate, 'YYYY-MM-DD') }}&nbsp&nbsp-&nbsp&nbsp{{
                  formatDate(Alldata.endDate, 'YYYY-MM-DD')
                }}
              </div>
            </div>
          </div>
          <div class="main-h">
            <div class="content">
              <div class="h-title">任务截止通知方式</div>
              <div class="h-text">{{ getIsnotify(Alldata.isNotify) }}</div>
            </div>
            <div class="content">
              <div class="h-title">任务发布通知方式</div>
              <div class="h-text">{{ getOptional(Alldata.optional) }}</div>
            </div>
            <div class="content">
              <div class="h-title">任务面向对象总人数</div>
              <div class="h-text">{{ Alldata.totalNum }}</div>
            </div>
            <div class="content">
              <div class="h-title">已完成人数</div>
              <div class="h-text">{{ Alldata.finishNum }}</div>
            </div>
          </div>
          <div class="main-h">
            <div class="content">
              <div class="h-title">完成率</div>
              <div class="h-text">
                <div v-if="Alldata.totalNum > 0">
                  {{
                    numFilter((Alldata.finishNum / Alldata.totalNum) * 100)
                  }}%
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="box_23 flex-col"></div>
        <div class="three-box">
          <!-- <div class="one">
        <div class="title"></div>
        <div class="content"></div>
    </div> -->
          <div class="one">
            <div class="title">面向组群</div>
            <div class="content">
              <div
                style="
                  overflow-y: auto;
                  overflow-x: hidden;
                  background: 249, 250, 250;
                "
              >
                <div
                  v-for="(item, index) in taskScopeGroupList"
                  :key="index"
                  style="display: inline-block"
                >


<el-tag><div class="text">{{ item.bizDesc }}</div></el-tag>

                </div>
              </div>
            </div>
          </div>

          <div class="one">
            <div class="title">经销商岗位设置 – 用以员工任务管理</div>

            <div class="content">
              <div
                style="
                  overflow-y: auto;
                  overflow-x: hidden;
                  background: 249, 250, 250;"
              >
                <div
                  v-for="(item, index) in positionItemList"
                  :key="index"
                  style="display: inline-block"
                >

                  <el-tag><div class="text">{{ item.bizDesc }}</div></el-tag >
                </div>
              </div>
            </div>
          </div>
          <div class="one">
            <div class="title">任务描述</div>

            <div class="content">
              <div class="task-script">
                {{ Alldata.content }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- pop -->
    <deleteComponent
      v-model="dialogVisible"
      :dialogVisible.sync="dialogVisible"
      :rowId.sync="taskId"
      @openEvent="openEvent"
      @closeEvent="closeEvent"
      @closeError="closeError"
    ></deleteComponent>
    <downComponent
      v-model="dialogVisibleReurn"
      :taskId.sync="taskId"
      @openDownEvent="openDownEvent"
      @closeDownEvent="closeDownEvent"
      :dialogVisibleReurn.sync="dialogVisibleReurn"
    ></downComponent>
  </div>
</template>
<script>
import moment from 'moment'
import deleteComponent from '@/components/task/Delete.vue'
import downComponent from '@/components/task/Down.vue'
export default {
  data() {
    return {
      changeBy: '',
      dialogVisibleReurn:false,
      isDeleteOk:false,
      dialogVisible: false,
      //
      isPubAgain: false,
      isPub: false,
      isEdit: false,
      isDown: false,
      isDel: false,
      positionItemList: [],
      taskScopeGroupList: [],
      taskId: '',
      Alldata: {},
      dot: {
        width: '6px',
        height: '6px',
        'border-radius': '5px',
      },
    }
  },
  methods: {
    formatPub(data){
if(data){
  return  (`(${data})`)
}
return ''
    },
    // 编辑权限
    checkEdit(){
      if(this.$hasPermission('joy:learning:task:edit')){
          return true
      }
      return false
    },
    // 下架权限
    checkDown(){
      if(this.$hasPermission('joy:learning:task:down')){
          return true
      }
      return false
    },
    // 删除权限
    checkDelete(){
      if(this.$hasPermission('joy:learning:task:delete')){
          return true
      }
      return false
    },
    // 发布权限
    checkPub(){
      if(this.$hasPermission('joy:learning:task:pub')){
          return true
      }
      return false
    },
    openEvent(){
     this.isDeleteOk=true
    },
    closeEvent(){
      this.isDeleteOk=false
    },
    closeError(){
      this.isDeleteOk=false
      this.querySearchDetail()
    },
    openDownEvent(){
      this.isDeleteOk=true
     },
     closeDownEvent(){
       this.isDeleteOk=false
       this.querySearchDetail()
     },
    deactivated() {
    let list = document.getElementsByClassName("el-tooltip__popper");
    console.log("🚀 ~ file: index.vue ~ line 309 ~ deactivated ~ list", list)
    if (list.length > 0) {
      list[list.length - 1].style.display = "none";
    }
},
    // edit event
    editTask(){
        this.$router.push({
          name: "newTask",
          query: { taskId: JSON.stringify(this.taskId) },
        });
        setTimeout(function () {
          // window.location.reload(0);
        }, 100);
        // console.log(">>>00",JSON.stringify(row))

        this.$eventHub.$emit("taskId", this.taskId);

    },
    delPop() {
      this.dialogVisible = true
    },
    downPop(){
      this.dialogVisibleReurn=true
    },


    getUserInfo () {
      return this.$request.get('/sys/commuser/userInfo').then((res) => {
        console.log(res.user,"res.user=================")
        this.changeBy=res.user.userCode

      }).catch(() => {})
    },

    //del btn
   async pubAgain() {

     const res= await
       this.$request.post(
          `/sys/common/updateTaskStatus?taskId=${this.taskId}&status=${2}&chngBy=${this.changeBy}`,
          {}
        )
        console.log("发布响应数据===================》",res)
        if(res){
          if(res.message){
            this.$message.error(res.message)
            this.querySearchDetail()
          }else{
          this.$message.success("任务发布中，请关注发布状态！")
          this.querySearchDetail()
        }
        return res
      }
    },
    // number style
    numFilter(value) {
      const realVal = parseFloat(value).toFixed(2)

      return realVal
    },

    getIsnotify(data) {
      if (data == 0) {
        return '不通知'
      }
      if (data == 1) {
        return '通知'
      }
    },
    getOptional(data) {
      if (data == 10) {
        return '站内信'
      }
      if (data == 20) {
        return '短信'
      }
      if (data == 30) {
        return '不通知'
      }
    },
    formatDate(date, format = 'YYYY-MM-DD HH:mm:ss') {
      return moment(date).format(format)
    },
    getBizType(data) {
      if (data == 1) {
        return '微课'
      } else if (data == 2) {
        return '资料'
      } else if (data == 3) {
        return '考试'
      } else if (data == 4) {
        return '慕课'
      } else if (data == 5) {
        return '调研'
      } else if (data == 6) {
        return '混合式学习'
      } else if (data == 7) {
        return '直播'
      } else if (data == 30) {
        return 'AI考试'
      }
    },
    getStatus(data) {
      if (data == 2) {
        return '已发布'
      }
      if (data == 0) {
        return '未发布'
      }
      if (data == 4) {
        return '发布中'
      }
      if (data == 5) {
        return '发布失败'
      }
      if (data == 3) {
        return '已下架'
      }
    },
    handleClick() {
      let tabName = this.$store.state.contentTabsActiveName
      if (tabName === 'home') {
        return false
      }
      this.$store.state.contentTabs = this.$store.state.contentTabs.filter(
        (item) => item.name !== tabName
      )
      if (this.$store.state.contentTabs.length <= 0) {
        this.$store.state.sidebarMenuActiveName =
          this.$store.state.contentTabsActiveName = 'home'
        return false
      } // 当前选中tab被删除
      if (tabName === this.$store.state.contentTabsActiveName) {
        this.$router.push({
          name: this.$store.state.contentTabs[
            this.$store.state.contentTabs.length - 1
          ].name,
        })
      }
    },
    // btn
    btnShow() {
      if (this.Alldata.status == 3) {
        if(this.Alldata.bizType ==3){
          (this.isPubAgain = false),
          (this.isPub = false),
          (this.isEdit = false),
          (this.isDel = false),
          this.isDown=false
        }else{
          ;(this.isPubAgain = false),
          (this.isPub = true),
          (this.isEdit = true),
          (this.isDel = true)
          this.isDown=false
        }

      }
      // todo
      if (this.Alldata.status == 5) {
        if(this.Alldata.bizType==3){
          (this.isPubAgain = true),
          (this.isPub = false),
          (this.isEdit = false),
          (this.isDel = false),
          this.isDown=false
        }else{
          this.isPubAgain = true
          this.isEdit=true
          this.isDel=true
          this.isPub=false,
          this.isDown=false
        }
      }
      if (this.Alldata.status == 0) {
        ;(this.isPubAgain = false),
          (this.isPub = true),
          (this.isEdit = true),
          (this.isDel = true),
          this.isDown=false
      }
      if(this.Alldata.status == 4){
        this.isPubAgain = false
        this.isEdit=false
        this.isDel=false
        this.isPub=false
        this.isDown=false
      }
      if (this.Alldata.status == 2) {
        if(this.Alldata.bizType ==3||this.Alldata.bizType ==30){
          this.isPubAgain = false
          this.isEdit=false
          this.isDel=false
          this.isPub=false
          this.isDown=false
        }else{
        (this.isPubAgain = false),
          (this.isPub = false),
          (this.isEdit = false),
          (this.isDel = false),
          this.isDown=true
      }}
      console.log(this.isDown,"==================thisisdown")
    },
    // 初始化数据
    querySearchDetail() {
    console.log(this.taskId,"方法的id数值，有没有过来")
      this.$request
        .post(`/sys/common/getTask?taskId=${this.taskId}`, {
        })
        .then((res) => {
          this.Alldata = res
          console.log(res, '响应数据===============')
          let list = []
          list = res.positionItemList
          // list.map((item) => {
          //   if (item.bizDesc) {
          //     this.positionItemList.push(item.bizDesc)
          //   }
          // })
          this.positionItemList=list
          let glist = []
          glist = res.taskScopeGroupList
          // glist.map((item) => {
          //   if (item.bizDesc) {
          //     this.taskScopeGroupList.push(item.bizDesc)
          //   }
          // })
          this.taskScopeGroupList=glist;
          this.btnShow()
        })
        .catch(() => {})
    },
  },
  created() {
   this.deactivated()
   this.getUserInfo()
    this.$eventHub.$on('show', (row) => {
      console.log(row, '传过来的值为')
      this.taskId = row.taskId
      console.log('id======================', this.taskId)
    })
    if (!this.taskId) {
      if (this.$route.query.show) {
        let show = JSON.parse(this.$route.query.show)
        console.log('=============================', show)
        this.taskId = show.taskId
        console.log('id===================', this.taskId)
      }
    }
    this.$eventHub.$on('taskId', (taskId) => {
      console.log(taskId, '传过来的值为')
      this.taskId = taskId
      console.log('id======================', this.taskId)
    })

    if (!this.taskId) {
      if (this.$route.query.taskId) {
        let taskId = JSON.parse(this.$route.query.taskId)
        console.log('=============================', taskId)
        this.taskId = taskId
        console.log('id===================', this.taskId)
      }
    }

    this.querySearchDetail()

  },
  components: {
    deleteComponent,
    downComponent
  },
  watch:{
      $route (to, from) {
       if(to||from){
    this.deactivated()
   this.querySearchDetail()
  }

  }
  },

}
</script>

<style lang="scss" scoped>
.contenthide {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 66px;
}
.task-all {
  // btn
  .task-header {
    width: 100%;
    height: 48px;
    background: #ffffff;
    .header-left {
      width: 60%;
    }
    .header-right {
      float: right;
      margin-top: 8px;
      margin-left: auto;
      display: flex;
      align-items: center;
      text-align: center;
      justify-content: center;
      margin-right: 24px;
      //  againpub
      .pub-again-btn {
        width: 104px;
        color: #ffff;
        height: 32px;
        background: #0bcb90!important;
        border-radius: 4px !important;
        border: none!important;
      }
      //   发布按钮
      .pub-btn {
        color: #ffff;
        width: 76px;
        height: 32px;
        background: #0bcb90;
        border-radius: 4px !important;
      }
      //  编辑按钮
      .edit-btn {
        width: 76px;
        height: 32px;
        background: #1c69d4;
        border-radius: 4px !important;
        color: #ffffff;
      }
      .down-btn {
        width: 76px;
        height: 32px;
        background: #ffffff!important;
        border-radius: 4px !important;
        opacity: 1;
        border:1px solid #dfe0e2;
        color: #1c69d4;
      }
      //   删除按钮
      .del-btn {
        width: 76px;
        height: 32px;
        background: #ffffff!important;
        border-radius: 4px !important;
        opacity: 1;
        border:1px solid #dfe0e2;
        color: #1c69d4;
      }
      //   返回按钮
      .back-btn {
        width: 76px;
        height: 32px;
        background: #ffffff!important;
        border-radius: 4px !important;
        border: 1px solid #dfe0e2;
        color:  #1c69d4;
      }
    }
  }
  //   main-top
  .main-top-content {
    display: flex;
    margin-top: 16px;
    width: 100%;
    height: 88px;
    background: #ffffff;
    border-radius: 4px;
    .hide{
    overflow: hidden;
    text-overflow: ellipsis;
    width: 138px;
    white-space: nowrap;
    }
    .task-status {
      display: flex;
      align-items: center;
      text-align: center;
      white-space:nowrap;
      margin-top:2px;
    }
    .verDivider {
      width: 1px;
      height: 67px;
      background-image: linear-gradient(#ccc 35%, rgba(255, 255, 255, 0) 0%);
      background-position: left;
      background-size: 1px 10px;
      background-repeat: repeat-y;
      margin: 13px 0 7px 0;
      margin-left: 30px !important;
    }
    .left {
      padding: 20px 0 0 24px;
      width: 20%;
    }
    .middle {
      width: 64%;
      display: flex;
      padding: 20px 0 0 9px;
    }
    .right {
      width: 8%;
      padding: 20px 0 0 14px;
    }
    .content {
      width: 26%;
      display: flex;
      flex-direction: column;
      row-gap: 3px;
      .title {
        width: 60px;
        height: 22px;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC, sans-serif;
        font-weight: 400;
        color: #999a9c;
        line-height: 22px;
      }
      .text {
        width: 187px;
        height: 22px;
        font-size: 14px;
        font-family: BMWTypeNextLatin-Regular, BMWTypeNextLatin, sans-serif;
        font-weight: 400;
        color: #252628;
        line-height: 22px;
      }
    }
  }
  .task-main-content {
    margin-top: 16px;
    width: 100%;
    height: 664px;
    background: #ffffff;
    border-radius: 4px;
    .block_42 {
      width: 97%;
      height: 1px;
      background: #eeeff0ff -1px 0px no-repeat;
      background-size: 98% 1px;
      margin: -7px 0 12px 24px;
    }
    // header style
    .header {
      display: flex;
      align-items: center;
      text-align: center;
      column-gap: 4px;
      padding: 24px 0 0 24px;
      .line {
        width: 3px;
        height: 14px;
        background: #1c69d4;
      }
      .title {
        width: 64px;
        height: 22px;
        font-size: 16px;
        font-family: PingFangSC-Medium, PingFang SC, sans-serif;
        font-weight: 500;
        color: #252628;
        line-height: 22px;
      }
    }
    // content style
    .content-all {
      .box_23 {
        width: 97%;
        height: 1px;
        margin: 16px 0 0 24px;
        background-image: -webkit-gradient(
          linear,
          left top,
          right top,
          color-stop(60%, #ccc),
          color-stop(0, hsla(0, 0%, 100%, 0))
        );
        background-image: linear-gradient(
          90deg,
          #ccc 60%,
          hsla(0, 0%, 100%, 0) 0
        );
        background-position: bottom;
        background-size: 10px 1px;
        background-repeat: repeat-x;
      }
      .content {
        display: flex;
        flex-direction: column;
        row-gap: 3px;

        .h-title {
          white-space: nowrap;
          width: 68px;
          height: 20px;
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC, sans-serif;
          font-weight: 400;
          color: #999a9c;
          line-height: 20px;
        }
        .h-text {
          width: 28px;
          height: 20px;
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC, sans-serif;
          font-weight: 400;
          color: #252628;
          line-height: 20px;
          white-space: nowrap;
          .hide {
            overflow: hidden;
            text-overflow: ellipsis;
            width: 188px;
            cursor: pointer;
          }
        }
      }
      // h
      .content-h {
        padding: 16px 0 0 36px;
      }
      //   main
      .content-main {
        .main-h {
          display: flex;
          padding: 24px 0 0 36px;
          column-gap: 18%;
        }
      }
      // box
      .three-box {
        display: flex;
        column-gap: 24px;

        .title {
          width: 60px;
          height: 22px;
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC, sans-serif;
          font-weight: 400;
          color: #999a9c;
          line-height: 22px;
          white-space: nowrap;
        }
        .content {
          opacity: 0.8;
          height: 168px;
          display: table-cell;
          margin-top: 20px;
          border-radius: 4px;
          border-color: #eff0f1;
          border: 2px solid #eff0f1;
          background: #ffffff;
          padding-top: 5px;
          padding-left: 10px;
          overflow: hidden auto;
        }
        .one {
          width: 30%;
          padding: 24px 0 0 36px;
          display: flex;
          flex-direction: column;
        }
      }
    }
  }
}
 ::-webkit-scrollbar {
  width: 7px;
  margin-top: 10px;
  height: 8px;
  outline: none;
  border: 0 none;
  background-color: rgba(255, 255, 255, 0.5) !important;
}
/*定义滚动条轨道 内阴影+圆角*/
::-webkit-scrollbar-track {
  box-shadow: rgba(255, 255, 255, 0.5) !important;
  -webkit-box-shadow: rgba(255, 255, 255, 0.5) !important;
  border-radius: 10px;
  background-color:  rgba(255, 255, 255, 0.5) ;
}
// /*定义滑块 内阴影+圆角*/
::-webkit-scrollbar-thumb {
  border-radius: 10px;
  box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.1);
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.1);
  background-color: #c8c8c8;
}
.el-tag {
  margin: 4px 4px 4px 4px;
  width: 92%;
  height: 24px;
  background: rgba(28, 105, 212, 0.08);
  border-radius: 3px;
  border: none;
  color: #1c69d4;
  .text {
    height: 12px;
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC, sans-serif;
    font-weight: 400;
    color: #1c69d4;
    line-height: 12px;
    justify-content: center;
    align-items: center;
    text-align: center;
    margin-top: 6px;
  }
  .task-script {
    overflow-y: auto;
    overflow-x: hidden;
    white-space: pre-line;
    margin-top: -12px;
  }
}
</style>
